import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail, MapPin } from "lucide-react";
import { SERVICES } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-dark text-bg mt-24" data-testid="site-footer">
      <div className="site-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <LogoLight />
              <span className="font-serif text-2xl leading-none">
                Xtreme <span className="italic text-accent">Care</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-bg/75 leading-relaxed">
              Compassionate home care and healthcare staffing across every
              Canadian province and territory. Bonded, insured, and staffed by
              licensed nurses.
            </p>
            <Link to="/contact" className="btn btn-primary mt-6" data-testid="footer-cta">
              Request Care <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow eyebrow-light">Services</div>
            <ul className="mt-4 space-y-2 text-bg/85">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="hover:text-accent transition-colors"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="text-accent hover:underline">
                  All services →
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow eyebrow-light">Company</div>
            <ul className="mt-4 space-y-2 text-bg/85">
              <li><Link to="/about" className="hover:text-accent">About</Link></li>
              <li><Link to="/careers" className="hover:text-accent">Careers</Link></li>
              <li><Link to="/blog" className="hover:text-accent">Journal</Link></li>
              <li><Link to="/locations" className="hover:text-accent">Locations</Link></li>
              <li><Link to="/contact" className="hover:text-accent">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow eyebrow-light">Contact</div>
            <ul className="mt-4 space-y-3 text-bg/85 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5" strokeWidth={1.75} />
                <a href="tel:8073558600" className="hover:text-accent" data-testid="footer-phone">807-355-8600</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5" strokeWidth={1.75} />
                <a href="mailto:admin@xtremecare.ca" className="hover:text-accent" data-testid="footer-email">admin@xtremecare.ca</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5" strokeWidth={1.75} />
                <span>Nationwide<br/>Canada</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-bg/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-bg/50 text-xs">
          <div>© {new Date().getFullYear()} Xtreme Care Services. All rights reserved.</div>
          <div className="uppercase tracking-widest">Compassionate care · nationwide</div>
        </div>
      </div>
    </footer>
  );
}

function LogoLight() {
  return (
    <svg width="30" height="30" viewBox="0 0 34 34" fill="none" aria-hidden>
      <circle cx="17" cy="17" r="6.5" fill="#C69749" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
        <line
          key={deg}
          x1="17"
          y1="17"
          x2="17"
          y2="4"
          stroke="#C69749"
          strokeWidth="1.5"
          strokeLinecap="round"
          transform={`rotate(${deg} 17 17)`}
        />
      ))}
    </svg>
  );
}
